import React                          from 'react'

import { Row, Col, Container }              from 'react-grid-system'
import { DragDropContext }                  from 'react-beautiful-dnd'
import { Divider, Button,
    Select, message, Tooltip, Modal, Checkbox, Input }       from 'antd'

import { bindActionCreators } from 'redux'
import { withRouter, Link }         from 'react-router-dom'
import { connect }            from 'react-redux'

import S3Uploader       from '../../components/Fs/Local/S3'
import B2Uploader       from '../../components/Fs/Local/B2'
import CloudFilesSystem from '../../components/Fs/Cloud/files-system'
import FtxFilesSystem   from '../../components/Fs/Ftx/files-system'
import BillingForm      from '../../components/Billing/BillingForm'

import {fetchBucketContent, selectBucket} from '../../actions/cloud-files-system-actions'
import { refresh_profile, refresh_rm }    from '../../actions/auth'
import { cloud_selection_changed }        from '../../actions/s3-direct-actions'
import { fetchCloudAccounts }             from '../../actions/cloud-accounts-actions'
import { play_file }                      from '../../actions/video-player'
import { clear_migration }                from '../../actions/migrations'
import CloudFlyerAPI                         from '../../api/CloudFlyerAPI'
import { sanitize_path }                  from '../../utils'
import AddCardForm                        from '../../components/Billing/AddCardForm'
import SecureLockIcon                     from '../../assets/img/security-lock.png'

import './styles.scss';
import warningIcon from '../../assets/img/warning.png';
import tickIcon from '../../assets/img/tick.png';
import ModalB from '../../components/UI/Modal/ModalB';
import Backdrop from '../../components/UI/Backdrop/Backdrop';
import {receiveError} from "../../api/http";
const {Option} = Select;
let state = null
let $this = null


class Xchange extends React.Component {
    constructor(props) {
        super(props)
        $this = this

        if (state) {
            $this.state = state
        } else {
            $this.state = {
                access_control: 'private',
                s3Acceleration: false,
                transfer_type: 'Direct',

                left_path: '/',
                right_path: '/',

                clouds: [],
                buckets: [],
                left_buckets: [],
                right_buckets: [],

                left_selected_cloud: null,
                left_selected_cloud_id: null,
                left_selected_bucket: null,
                left_selected_bucket_id: null,
                left_file_selection_count: 0,
                left_clouds_selection_disabled: false,
                left_bucket_selection_disabled: false,

                right_selected_cloud: null,
                right_selected_cloud_id: null,
                right_selected_bucket: null,
                right_selected_bucket_id: null,
                right_file_selection_count: 0,
                right_clouds_selection_disabled: false,
                right_bucket_selection_disabled: false,

                transfer_button_disabled: false,
                transfer_prifx_button_disabled: false,

                is_drop_disabled: false,
                is_drag_disabled: false,
                loading: false,
                skipFiles: false,

                // POP up
                popUp:false,
                popUpMessage:{},

                selection: {
                    size: 0,
                    cost: 0,
                    count: 0,
                },
                servers: {
                    wasabi: window.FTX_HOST_WASABI, //'147.75.62.78',
                    aws: window.FTX_HOST, //'35.168.222.77'
                },
                c2cModalVisible: false,
                ftxModalVisible: false,
                checkVal: false,
                selectedAccountId: "",
                prefix: "",
                userId: "",
                userList: [],
                accountList: [],
            }
        }

        this.onChangeAccount = this.onChangeAccount.bind(this);
        this.onChangeUser = this.onChangeUser.bind(this);
    }

    onChangeAccount(value) {
        console.log(`selected ${value}`);

        this.setState({
            selectedAccountId: value,

            left_selected_cloud: null,
            left_selected_cloud_id: null,
            left_selected_bucket: null,
            left_selected_bucket_id: null,
            left_file_selection_count: 0,
            left_clouds_selection_disabled: false,
            left_bucket_selection_disabled: false,

            right_selected_cloud: null,
            right_selected_cloud_id: null,
            right_selected_bucket: null,
            right_selected_bucket_id: null,
            right_file_selection_count: 0,
            right_clouds_selection_disabled: false,
            right_bucket_selection_disabled: false,  
           
            prefix: "",
            userId: "",
            userList: [],
       
        });
            CloudFlyerAPI.user_account
                .getUsersByAccount(value, 0, 0)
                .then(({data}) => {
                    console.log(data, "userList")
                    this.setState({
                        userList: data.data,
                    });
                })
                .catch((err) => {
                    const msg = receiveError(null, err).message;
                    message.error(msg);
                });
    }


    onChangeUser(value) {
        console.log(`selected ${value}`);
        this.setState({
            userId: value,
            loading: true,
        },()=>{

        });
    }
    componentWillReceiveProps(props) {
        setTimeout(async () => {
            $this.setState(
                {
                    alert_content: props.contentAlert,
                    clouds: props.clouds,
                });
            //         // () => {
            //             if (!(!$this.isInitiated && ($this.state.clouds || []).length > 1)) return
            //             $this.isInitiated = true;

            //             let left_selected_cloud = props.clouds.filter(c => c.cloudType == 1)[0] || {};
            //             let left_selected_cloud_id = left_selected_cloud.id;
            //             let right_selected_cloud = props.clouds.filter(c => c.cloudType == 2)[0] || {};
            //             let right_selected_cloud_id = right_selected_cloud.id;

            //             // let right_selected_cloud = $this.state.clouds[1] || {}
            //             // let right_selected_cloud_id = right_selected_cloud.id
            //             // let right_selected_bucket =(right_selected_cloud.storages || [])[0] || {}
            //             // let right_selected_bucket_id = right_selected_bucket.id

            //             $this.setState({
            //                 left_selected_cloud,
            //                 left_selected_cloud_id,
            //                 right_selected_cloud,
            //                 right_selected_cloud_id,

            //                 // right_selected_cloud,
            //                 // right_selected_cloud_id,
            //                 // right_selected_bucket,
            //                 // right_selected_bucket_id,
            //             })


            //     //     }
            //     // )


            let left_selected_cloud = this.state.left_selected_cloud
            let left_selected_cloud_id = this.state.left_selected_cloud_id;
            let right_selected_cloud = this.state.right_selected_cloud
            let right_selected_cloud_id = this.state.right_selected_cloud_id;

            if(left_selected_cloud === null && this.state.right_selected_cloud === null && props.clouds.length !== 0){

                left_selected_cloud = props.clouds[0] || {};
                left_selected_cloud_id = left_selected_cloud.id;
                right_selected_cloud = props.clouds.filter(c => c.cloudType == 2)[0] || {};
                right_selected_cloud_id = right_selected_cloud.id;


                $this.setState({
                    left_selected_cloud,
                    left_selected_cloud_id,
                    right_selected_cloud,
                    right_selected_cloud_id,
                })

                if(left_selected_cloud_id !== null && right_selected_cloud_id !== null){
                    await this.fetch_bucket_handler('left', left_selected_cloud_id);
                }

                if(right_selected_cloud_id !== null){
                    await this.fetch_bucket_handler('right', right_selected_cloud_id);
                }
            }



        }, 500)

    }

    componentDidCatch(e, err) {
        console.log('componentDidCatch', err)
    }

    componentWillUnmount() {
        state = this.state
    }

    componentDidMount() {
        this.setState({ c2cModalVisible: false, ftxModalVisible: false, popUp:false})

        CloudFlyerAPI.user_account
            .fetchAllAccounts(0, 0, null)
            .then(({data}) => {
                console.log(data, "accountList")
                this.setState({
                    accountList: data.data,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }


    on_transfer_type_change = value => {
        let left_selected_cloud = $this.state.left_selected_cloud
        let left_selected_cloud_id = $this.state.left_selected_cloud_id
        if (value === 'Ftx') {
            left_selected_cloud = $this.state.clouds[0]
            left_selected_cloud_id = null
        }

        $this.setState({
            transfer_type: value,
            s3Acceleration: value === 's3Acceleration',
            left_selected_cloud,
            left_selected_cloud_id,
        })
    }

    on_browse = (side, path) => $this.setState({[`${side}_path`]: path})

    on_transfer_complete = () =>
        $this['right'].browse(
            $this.state.right_selected_bucket,
            $this['right'].state
        )

    fetch_bucket_handler = async (side, id) =>{
        let payload = {};
        payload.cloudAccountId = id;
        await CloudFlyerAPI.new_cloud_accounts.buckets(payload)
            .then(function(res){
                let buckets = res.data
                let selected_bucket = res.data[0].name;
                let selected_bucket_id = selected_bucket;
                // console.log("all buckets",side ,res);

                $this.setState({
                    [`${side}_buckets`]: buckets,
                    [`${side}_selected_bucket`]: selected_bucket,
                    [`${side}_selected_bucket_id`]: selected_bucket_id,
                    [`${side}_path`]: '/'
                })
            })
            .catch(function(err){
                console.log(err);
            })
    }


    on_bucket_change = (side, id) => {
        console.log("on bucket change", side , id);
        $this.setState({
            [`${side}_selected_bucket`]: id,
            [`${side}_selected_bucket_id`]: id,
            [`${side}_path`]: ''
        })

        // let bucket = ($this.state[side + '_selected_cloud'].storages || []).filter(c => c.id === id)[0] || {}
        // $this.setState(
        //     {
        //         [`${side}_selected_bucket`]: bucket,
        //         [`${side}_selected_bucket_id`]: id,
        //         [`${side}_path`]: ''
        //     })
    }

    on_cloud_change = async (side, id) => {
        let cloud = $this.state.clouds.filter(c => c.id === id)[0] || {}
        $this.setState({
            [`${side}_selected_cloud`]:cloud,
            [`${side}_selected_cloud_id`]:cloud.id,
            [`${side}_selected_bucket`]: null,
            [`${side}_selected_bucket_id`]: null,
            [`${side}_path`]: '/'
        })

        await this.fetch_bucket_handler( side, cloud.id);

        // let cloud = $this.state.clouds.filter(c => c.id === id)[0] || {}
        // window.FTX_HOST =
        //     $this.state.servers[cloud.account_type_id] || $this.state.servers.aws
        // console.log('server changed to ' + window.FTX_HOST)

        // $this.setState(
        //     {
        //         [side + '_selected_cloud']: cloud,
        //         [side + '_selected_cloud_id']: id,
        //     },
        //     () => {
        //         let transfer_type = $this.state.transfer_type
        //         if (id === null) transfer_type = 'Direct'
        //         else if (side === 'left' && transfer_type === 'Ftx')
        //             transfer_type = 'Direct'

        //         $this.setState(
        //             {
        //                 transfer_type,
        //                 s3Acceleration: transfer_type === 's3Acceleration',
        //                 transfer_button_disabled:
        //                     !(
        //                         ($this.state.left_file_selection_count &&
        //                             !$this.state.right_file_selection_count) ||
        //                         (!$this.state.left_file_selection_count &&
        //                             $this.state.right_file_selection_count)
        //                     ) || !this.left,
        //             },
        //             () =>
        //                 $this.on_bucket_change(
        //                     side,
        //                     (
        //                         (($this.state[side + '_selected_cloud'] || {})
        //                             .storages || [])[0] || {}
        //                     ).id
        //                 )
        //         )
        //     }
        // )
    }

    file_selection_changed = (side, files = []) => {
        $this.setState(
            {
                [`${side}_file_selection_count`]: files.filter(_ => _.checked)
                    .length,
            },
            () =>
                $this.setState({
                    transfer_button_disabled:
                        !(
                            ($this.state.left_file_selection_count &&
                                !$this.state.right_file_selection_count) ||
                            (!$this.state.left_file_selection_count &&
                                $this.state.right_file_selection_count)
                        ) || !this.left,
                })
        )
    }

    transfer = (path) => {
        // console.log("in transfer",this.state);

        // let {
        //     bucket: {
        //         cloud_account_id: source_cloud_account_id,
        //         bucket_name: source_bucket_name,
        //         id : source_bucket_id
        //     } = {}
        // } = source_pane.props
        // let {
        //     bucket: {
        //         cloud_account_id: dest_cloud_account_id,
        //         bucket_name: dest_bucket_name,
        //         id : dest_bucket_id
        //     } = {},
        //     path: dest_path
        // } = dest_pane.props

        let payload ={
            userId:this.state.userId,
            sourceCloudAccountId: this.state.left_selected_cloud_id,
            sourceBucket: this.state.left_selected_bucket,
            sourcePath: path,
            destinationCloudAccountId: this.state.right_selected_cloud_id,
            destinationBucket: this.state.right_selected_bucket,
            destinationPath: this.state.right_path,
            transferType: 1,
            allowSkip: true
        }


        CloudFlyerAPI.transfer.migration.move(payload)
            .then(function(res){

                $this.setState({
                    loading: false,
                    popUp: true,
                    popUpMessage:{
                        icon:tickIcon,
                        header:"Transfer Started",
                        text:{
                            1:"Your transfer has successfully started.",
                            2:"Please check the transfer status."
                        },
                        button:"Transfer Status"
                    }
                })

            })
            .catch(function(err){
                console.log(err);
                // $this.setState({ loading: false }, () => {
                // message.error(
                //     ((err.response || {}).data || {}).message ||
                //         'An error occurred while trying to enqueue the transfer, please try again'
                // )
                //     dest_pane.remove_files(selected_files)
                //     source_pane.add_files(selected_files, index_source)
                // })
            })




        // source_bucket_id = source_bucket_id.replace(source_cloud_account_id + '/', '')
        // dest_bucket_id   = dest_bucket_id.replace(dest_cloud_account_id + '/', '')

        // if ($this.state.transfer_type !== 'Ftx' &&
        //     (source_cloud_account_id === dest_cloud_account_id &&
        //         source_bucket_name === dest_bucket_name))
        //     return $this.setState({ dragging_id: null })

        // let selected_files = []
        // let drag_file = (source_pane.state.files.filter(f => f.path === drag_file_path) || [])[0]
        // if (drag_file && !drag_file.checked) selected_files.push(drag_file)
        // else selected_files = source_pane.state.files.filter(f => f.checked)

        // if (selected_files.length === 0)
        //     return message.warn('Please select files to transfer')
        // else if (source_pane.side === dest_pane.side)
        //     source_pane.reorder(selected_files, index_source, index_dest)
        // else {
        //     if (type === 0) source_pane.remove_files(selected_files)
        //     dest_pane.add_files(selected_files, index_dest)

        //     $this.setState({ loading: true }, this.props.refresh_rm)

        //     let {
        //         quota: { c2c: { organization: quota = {} } = {} } = {}
        //     } = this.props.user
        //     let total_size = selected_files
        //         .map(f => f.size)
        //         .reduce((prev, curr) => prev + curr)

        //     const {user: {organization: { confirmed_c2c, confirmed_ftx }}} = this.props

        //debugger

        //!($this.state.left_selected_cloud.account_type_id === 'wasabi' && $this.state.right_selected_cloud.account_type_id === 'wasabi')  &&
        // if ((!confirmed_c2c || !confirmed_ftx)) {
        //     if ($this.state.transfer_type === 'Ftx' && !confirmed_ftx) {
        //         dest_pane.remove_files(selected_files)
        //         source_pane.add_files(selected_files, index_source)
        //         return this.setState({ ftxModalVisible: true })
        //     }
        //     else if ($this.state.transfer_type !== 'Ftx' && !confirmed_c2c)
        //     {
        //         dest_pane.remove_files(selected_files)
        //         source_pane.add_files(selected_files, index_source)
        //         return this.setState({c2cModalVisible: true})
        //     }
        // }

        // let api =
        //     $this.state.transfer_type === 'Ftx'
        //         ? CloudFlyerAPI.ftx
        //         : CloudFlyerAPI.transfer.migration
        // api.move({
        //     files: selected_files.map(_ => ({
        //         path:
        //             $this.state.transfer_type === 'Ftx'
        //                 ? _.path
        //                 : sanitize_path(`${_.path}${_.type === 'FS_FILE_TYPE_FILE' || !_.size ? '' : '/'}`, false),

        //         file_id     : _.file_id,
        //         bucket_name : source_bucket_name,
        //         bucket_id   : source_bucket_id
        //     })),
        //     cloud_id: source_cloud_account_id,
        //     type,
        //     destination: {
        //         cloud_id: dest_cloud_account_id,
        //         bucket_name: dest_bucket_name,
        //         bucket_id: dest_bucket_id,
        //         path: sanitize_path(dest_path)
        //     },
        //     skip_active:$this.state.skipFiles,
        //     user_id:
        //         $this.state.transfer_type === 'Ftx'
        //             ? (this.props.user || {}).id
        //             : null,
        // })

        // .then(res =>
        //     $this.setState({
        //         loading: false,
        //         popUp: true,
        //         popUpMessage:{
        //             icon:tickIcon,
        //             header:"Transfer Started",
        //             text:{
        //                 1:"Your transfer has successfully started.",
        //                 2:"Please check the transfer status."
        //             },
        //             button:"Transfer Status"
        //         }
        //     }, () =>
        //         this.props.clear_migration(
        //             null, () => {}
        //             // message.success(
        //             //     ((res || {}).data || {}).message ||
        //             //         'Transfer enqueue successfully'
        //             // )

        //         )
        //     )
        // )
        // .catch(err =>
        //     $this.setState({ loading: false }, () => {
        //         message.error(
        //             ((err.response || {}).data || {}).message ||
        //                 'An error occurred while trying to enqueue the transfer, please try again'
        //         )
        //         dest_pane.remove_files(selected_files)
        //         source_pane.add_files(selected_files, index_source)
        //     })
        // )
        // }

        // $this.setState({
        //     dragging_id: null,
        //     transfer_button_disabled:
        //         !(
        //             ($this.state.left_file_selection_count &&
        //                 !$this.state.right_file_selection_count) ||
        //             (!$this.state.left_file_selection_count &&
        //                 $this.state.right_file_selection_count)
        //         ) || !this.left,
        // })
    }

    on_drag_start = drag => {
        console.log('drag ' + drag.draggableId)
        return $this.setState({ dragging_id: drag.draggableId })
    }

    on_drag_end = result => {
        result = result || { source: {}, destination: {} }
        if (result.reason !== 'DROP' || !result.source || !result.destination)
            return $this.setState({ dragging_id: null })

        const {
            source: { droppableId: drop_source, index: index_source } = {},
            destination: { droppableId: drop_dest, index: index_dest } = {},
            draggableId: drag_file_path = '',
        } = result
        console.log('drop' + result.draggableId)
        if (
            !drop_dest ||
            (!this.left && drop_source !== drop_dest) ||
            !this.right
        )
            return $this.setState({ dragging_id: null })

        let source_pane = this[drop_source]
        let dest_pane = this[drop_dest]

        this.transfer(result.draggableId.replace(/^left/, ""))
    }

    on_transfer = is_copy => {
        this.transfer("/")
        this.setState({transfer_button_disabled: true})
    }
    on_transfer_prfix = is_copy => {
        this.transfer(this.state.prefix)
        this.setState({transfer_button_disabled: true})
    }

    on_transfer_status = (e) => {
        let { history } = $this.props
        history = history|| window.appHistory
        history.push('/mboard')
    }

    on_calc_price = (e) => {
        let { history } = $this.props
        history = history|| window.appHistory
        history.push('/calc')
    }


    CloudFlyerAPI = async (payload) => {
        try{
            const {data} = await CloudFlyerAPI.new_user_account.transferStatus(payload);
            return data;
        }
        catch(err){
            console.log(err);
        }
    }

    on_checkbox_change = (value) => {
        this.setState({skipFiles: value})
    }

    //  to close the popUp using the backdrop
    backdropClosePopupHandler = () =>{
        $this.setState({ popUp: false })
    }

    //to either navigate or close the popUp using the button
    closePopUpHandler = () => {
        switch ($this.state.popUpMessage.button) {
            case "Transfer Status":
                $this.setState({ popUp: false })
                $this.props.history.push('/mboard')
            default:
                $this.setState({ popUp: false })
        }
    }
    //to either navigate or close the popUp using the button
    handleCheckChange = (event) => {
        $this.setState({ checkVal: event.target.checked })
    }

    addPrefix = (event) => {
        $this.setState({ prefix: event.target.value })
    }

    render() {
        // console.log("$this.state.left_bucket_data", this.state.left_bucket_data);
        const {
            s3Acceleration = false,
            transfer_type = 'Direct',
            access_control = 'private',
            clouds,
            left_buckets,
            right_buckets,

            is_drop_disabled,
            is_drag_disabled,
            dragging_id,
            skipFiles,

            // left_selected_cloud = {},
            // left_selected_cloud: { storages: left_buckets = [] } = {},
            left_bucket_selection_disabled,
            left_selected_cloud,
            left_selected_cloud_id,
            left_selected_bucket,
            left_selected_bucket_id,
            left_clouds_selection_disabled,
            left_path = '/',

            right_bucket_selection_disabled,
            right_selected_cloud,
            right_selected_cloud_id,
            right_selected_bucket,
            right_selected_bucket_id,
            right_clouds_selection_disabled,
            right_path = '/',

            // right_selected_cloud = {},
            // right_selected_cloud: { storages: right_buckets = [] } = {},

            transfer_button_disabled,
            c2cModalVisible,
            ftxModalVisible,

        } = $this.state

        const { user, history } = this.props

        // POP UPS
        const popUpComponent = $this.state.popUp ?
            <div>
                <Backdrop show={$this.state.popUp} close={this.backdropClosePopupHandler}/>
                <ModalB
                    show={$this.state.popUp}
                    icon={$this.state.popUpMessage.icon}
                    header={$this.state.popUpMessage.header}
                    text={$this.state.popUpMessage.text}
                    button={$this.state.popUpMessage.button}
                    close={this.closePopUpHandler}
                />
            </div>:null;

        return (
            <div>
                {popUpComponent}
                {/* {c2cModalVisible && (
                    <XChangeConfirmModal
                        user={user}
                        header="Cloud To Cloud Transfer"
                        id="c2c"
                        refresh_profile={this.props.refresh_profile}
                        history={history}
                    />
                )}
                {ftxModalVisible && (
                    <XChangeConfirmModal
                        user={user}
                        header="Ftx Transfer"
                        id="ftx"
                        refresh_profile={this.props.refresh_profile}
                        history={history}
                    />
                )} */}

                <DragDropContext
                    onDragEnd={this.on_drag_end}
                    onDragStart={this.on_drag_start}>
                    <Container className="x_change" fluid>
                        <div className="main-wrapper">

                            {/* Header ------------------------ */}
                            <div className="header">
                                <h2>Migration</h2>

                                <div className="dropdowns-wrapper">

                                    Account:
                                    <Select
                                        showSearch
                                        style={{width: 200}}
                                        placeholder="Search to Select"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                        onChange={this.onChangeAccount}
                                    >
                                        {
                                            this.state.accountList.map((data, index) => (
                                                <Option key={index} value={data.id}>{data.name}</Option>
                                            ))
                                        }
                                    </Select>
                                    &nbsp;&nbsp;&nbsp;&nbsp; User:
                                    <Select
                                        showSearch
                                        style={{width: 200}}
                                        placeholder="Search to Select"
                                        value={this.state.userId}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                        onChange={this.onChangeUser}
                                    >
                                        {
                                            this.state.userList.map((data, index) => (
                                                <Option key={index} value={data.id}>{data.username}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>

                                {/* <div className="transfer-status">

                                    <Button
                                        type="primary"
                                        onClick={e=> {
                                            this.on_transfer_status()
                                        }}>
                                        Transfer Status
                                    </Button>
                                </div> */}
                            </div>

                            <div className="transfer-wrapper">
                                {/* Left Side ------------------------ */}
                                <div className="left-container">
                                    <h3 className="single-transfer-header">
                                        <span>1</span>Select Source
                                    </h3>
                                    <div className="single-transfer-menu">
                                        <div className="subtitle">
                                            <span className={'x-title'}>
                                                Source Account
                                            </span>
                                            <Select
                                                // placeholder="Account"
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                defaultValue = {left_selected_cloud}
                                                value = {left_selected_cloud_id}
                                                onChange = { e => this.on_cloud_change('left', e)}
                                                disabled = {left_clouds_selection_disabled}
                                                size = {'large'}
                                                dropdownMatchSelectWidth = {false}
                                                className = {'transfer-select'}
                                                dropdownClassName = "single-transfer-dropdown">
                                                {clouds.map((f, index) => (
                                                    <Select.Option
                                                        key={index}
                                                        value={f.id}>
                                                        {f.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </div>

                                        {/* {left_selected_cloud_id && ( */}
                                        <div className="subtitle">
                                                <span className={'x-title'}>
                                                    Source Bucket
                                                </span>
                                            <Select
                                                //placeholder = "Search In Buckets"
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }

                                                value = {left_selected_bucket_id}
                                                onChange = {e =>this.on_bucket_change('left',e)}
                                                disabled = {left_bucket_selection_disabled}
                                                size = {'large'}
                                                dropdownMatchSelectWidth = {false}
                                                className = {'transfer-select'}
                                                dropdownClassName = "single-transfer-dropdown">
                                                {left_buckets.map((f, index) => (
                                                        <Select.Option
                                                            key={index}
                                                            value={f.name}>
                                                            {f.name}
                                                        </Select.Option>
                                                    )
                                                )}
                                            </Select>
                                        </div>
                                        {/* )} */}

                                        <div className="transfer-skip-div">
                                            <div>
                                                <Checkbox checked={skipFiles} onChange={(e) => this.on_checkbox_change(e.target.checked)}>Skip Existing Files</Checkbox>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="checkboxes">
                                        <div className="checkbox-wrapper">
                                            <Checkbox onChange={this.handleCheckChange} checked={this.state.checkVal}></Checkbox>
                                            <Input placeholder="Enter Prefix to List"
                                                   disabled={!this.state.checkVal} onKeyUp={this.addPrefix} />
                                            <Button
                                                disabled={!this.state.checkVal} onClick={() => this.on_browse('left', this.state.prefix)}>List Objects</Button>
                                        </div>
                                    </div>



                                    <CloudFilesSystem
                                        ref={e => (this.left = e)}
                                        {...$this.props}
                                        side={'left'}
                                        account_id = {this.state.selectedAccountId}
                                        cloud={left_selected_cloud}
                                        bucket={left_selected_bucket}
                                        path={left_path}
                                        user={user}
                                        any_cloud_accounts={clouds.length}
                                        is_drop_disabled={true}
                                        is_drag_disabled={is_drag_disabled}
                                        dragging_id={dragging_id}
                                        on_browse={p => this.on_browse('left', p)}
                                        file_selection_changed = { _ => this.file_selection_changed('left', _)}
                                    />

                                    {/* {left_selected_cloud_id ? (
                                        <CloudFilesSystem
                                            ref={e => (this.left = e)}
                                            {...$this.props}
                                            side={'left'}
                                            cloud={left_selected_cloud}
                                            bucket={left_selected_bucket}
                                            path={left_path}
                                            user={user}
                                            any_cloud_accounts={clouds.length}
                                            is_drop_disabled={is_drop_disabled}
                                            is_drag_disabled={is_drag_disabled}
                                            dragging_id={dragging_id}
                                            on_browse={p => this.on_browse('left', p)}
                                            file_selection_changed = { _ => this.file_selection_changed('left', _)}
                                        />
                                    )
                                    : transfer_type === 'Ftx' ? (
                                        <FtxFilesSystem
                                            ref={e => (this.left = e)}
                                            {...$this.props}
                                            side={'left'}
                                            cloud={right_selected_cloud}
                                            bucket={right_selected_bucket}
                                            path={left_path}
                                            is_drop_disabled={is_drop_disabled}
                                            is_drag_disabled={is_drag_disabled}
                                            dragging_id={dragging_id}
                                            on_complete={this.on_transfer_complete}
                                            on_browse={p =>
                                                this.on_browse('left', p)
                                            }
                                            file_selection_changed={_ =>
                                                this.file_selection_changed(
                                                    'left',
                                                    _
                                                )
                                            }
                                        />
                                    )
                                    : (
                                        right_selected_cloud.account_type_id === 'backblaze' ?
                                            (<B2Uploader
                                            {...$this.props}
                                            side={'local'}
                                            s3Acceleration={s3Acceleration}
                                            access_control={access_control}
                                            cloud={right_selected_cloud}
                                            bucket={right_selected_bucket}
                                            path={right_path}
                                            user={user}
                                            any_cloud_accounts={clouds.length}
                                            is_drop_disabled={is_drop_disabled}
                                            is_drag_disabled={is_drag_disabled}
                                            on_complete={this.on_transfer_complete}
                                        />) : (<S3Uploader
                                                {...$this.props}
                                                side={'local'}
                                                s3Acceleration={s3Acceleration}
                                                access_control={access_control}
                                                cloud={right_selected_cloud}
                                                bucket={right_selected_bucket}
                                                path={right_path}
                                                user={user}
                                                any_cloud_accounts={clouds.length}
                                                is_drop_disabled={is_drop_disabled}
                                                is_drag_disabled={is_drag_disabled}
                                                on_complete={this.on_transfer_complete}
                                            />)
                                    )
                                    } */}
                                </div>

                                {/* Right Side -------------------------------*/}

                                <div className="right-container">
                                    <h3 className="single-transfer-header">
                                        <span>2</span>Select Destination
                                    </h3>

                                    {/* md={6}
                                    style={{ borderLeft: '1px solid white' }}> */}
                                    <div className="single-transfer-menu">
                                        <div className="subtitle">
                                            <span className={'x-title'}>
                                                Destination Account
                                            </span>
                                            <Select
                                                // placeholder="wasabi"
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                value = {right_selected_cloud_id}
                                                onChange = {e =>this.on_cloud_change('right', e)}
                                                disabled = {right_clouds_selection_disabled}
                                                size = {'large'}
                                                dropdownMatchSelectWidth = {false}
                                                className = {'transfer-select'}
                                                dropdownClassName = "single-transfer-dropdown">
                                                {clouds.filter(cl => cl.cloudType == 2).map((f, index) => (
                                                    <Select.Option
                                                        key={index}
                                                        value={f.id}>
                                                        {f.name}
                                                    </Select.Option>
                                                ))}

                                                {/* {clouds.slice(1).map((f, index) => (
                                                    <Select.Option
                                                        key={index}
                                                        value={f.id}>
                                                        {f.project_name}
                                                    </Select.Option>
                                                ))} */}
                                            </Select>
                                        </div>

                                        <div className="subtitle">
                                            <span className={'x-title'}>
                                                Destination Bucket
                                            </span>
                                            <Select
                                                // placeholder="Bucket"
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }

                                                value={right_selected_bucket_id}
                                                onChange={e =>this.on_bucket_change('right',e)}
                                                disabled={right_clouds_selection_disabled}
                                                size={'large'}
                                                dropdownMatchSelectWidth={false}
                                                className={'transfer-select'}
                                                dropdownClassName="single-transfer-dropdown">
                                                {right_buckets.map((f, index) => (
                                                    <Select.Option
                                                        key={index}
                                                        value={f.name}>
                                                        {f.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </div>

                                        <div>
                                            {/* <span className={'x-title'}>
                                                Transfer Using
                                            </span> */}
                                            <Select
                                                value={transfer_type}
                                                onChange={e =>this.on_transfer_type_change(e)}
                                                size={'large'}
                                                className={'transfer-select-type'}
                                                dropdownClassName="single-transfer-dropdown">

                                                <Select.Option value={'Direct'}>
                                                    Direct
                                                </Select.Option>
                                                {/* <Select.Option
                                                    value={'s3Acceleration'}>
                                                    Accelerator
                                                    </Select.Option> */}
                                                <Select.Option value={'Ftx'}>
                                                    ftX
                                                </Select.Option>
                                            </Select>
                                        </div>

                                        <div className="transfer-status">
                                            <Button
                                                onClick = { e => {this.on_transfer_status(e)}}
                                            >
                                                Transfer Status
                                            </Button>
                                        </div>
                                    </div>

                                    <CloudFilesSystem
                                        ref={e => (this.right = e)}
                                        {...$this.props}
                                        side={'right'}
                                        accountId = {this.state.selectedAccountId}
                                        cloud={right_selected_cloud}
                                        bucket={right_selected_bucket}
                                        path={right_path}
                                        user={user}
                                        any_cloud_accounts={clouds.length}
                                        is_drop_disabled={is_drop_disabled}
                                        is_drag_disabled={true}
                                        dragging_id={dragging_id}
                                        on_browse={p => this.on_browse('right', p)}
                                        file_selection_changed={_ =>this.file_selection_changed('right', _)}
                                    />
                                    {/* <div className={'transfer-actions'}> */}

                                    {/* disabled the move button ----------------     */}
                                    {/* <Tooltip title={'Move the selected files'}>
                                            <button
                                                className="single-transfer-button"
                                                onClick={() =>
                                                    this.on_transfer(false)
                                                }
                                                disabled={transfer_button_disabled}>
                                                Move
                                            </button>
                                        </Tooltip> */}
                                    {/* --------------------------------------------     */}
                                    {/* <Tooltip title={'Copy the selected files'}>
                                            <button
                                                className="single-transfer-button"
                                                onClick={() =>
                                                    this.on_transfer(true)
                                                }
                                                disabled={transfer_button_disabled}>
                                                Copy
                                            </button>
                                        </Tooltip> */}
                                    {/* </div> */}
                                </div>
                            </div>

                            <div className="exchange-actions">
                                <Tooltip title={'Copy Using Prefix'}>
                                    <Button
                                        className="transfer-button"
                                        onClick={() =>
                                            this.on_transfer_prfix(true)
                                        }
                                        disabled={!this.state.checkVal}
                                    >
                                        Copy Using Prefix
                                    </Button>
                                </Tooltip>
                                <Tooltip title={'Copy the entire bucket'}>
                                    <Button
                                        className="transfer-button"
                                        onClick={() =>
                                            this.on_transfer(true)
                                        }
                                    >
                                        Copy Entire Buckets
                                    </Button>
                                </Tooltip>
                            </div>
                        </div>
                        <BillingForm
                            user={this.props.user}
                            refresh={this.props.refresh_profile}
                            ref={form => (this.billing_form = form)}
                        />

                    </Container>
                </DragDropContext>
            </div>
        )
    }
}

// class XChangeConfirmModal extends React.Component {
//     constructor(props) {
//         super(props)

//         const { is_cbs } = this.props.user.organization
//         this.state = {
//             confirmed: true,
//             visible: this.props.visible !== undefined ? !is_cbs : true,
//             addCardVisible: false,
//             hasCard: false,

//             cc: {
//                 firstName: '',
//                 lastName: '',
//                 number: '',
//                 expiry: '',
//                 cvc: '',
//                 focused: 'number',
//                 valid: false,
//             },
//         }
//     }

//     handleCCFocus = target => {
//         this.setState({
//             cc: {
//                 ...this.state.cc,
//                 focused:
//                     target.name === 'firstName' || target.name === 'lastName'
//                         ? 'name'
//                         : target.name,
//             },
//         })
//     }

//     handleCCChange = target => {
//         const cc = { ...this.state.cc }

//         if (target.name === 'number') {
//             cc[target.name] = target.value.replace(/ /g, '')
//         } else if (target.name === 'expiry') {
//             cc[target.name] = target.value.replace(/[ \/]/g, '')
//         } else {
//             cc[target.name] = target.value
//         }

//         this.setState({ cc })
//     }

//     ccCallback = (type, isValid) => {
//         this.setState({
//             cc: {
//                 ...this.state.cc,
//                 valid: isValid,
//             },
//         })
//     }

//     confirm = () => {
//         const { cc, hasCard } = this.state
//         const { user } = this.props

//         console.log('confirming ... ')

//         if (!hasCard) {
//             CloudFlyerAPI.billing
//                 .addCreditCard({
//                     full_number: cc.number,
//                     first_name: cc.firstName,
//                     last_name: cc.lastName,
//                     expiration_month: cc.expiry.slice(0, 2),
//                     expiration_year: cc.expiry.slice(2, 4),
//                     billing_address: '',
//                     billing_city: '',
//                     billing_state: '',
//                     billing_country: '',
//                     billing_zip: '',
//                 })
//                 .then(res => {
//                     message.success('Credit Card Added Successfully')
//                     this.setState({ visible: false })
//                     this.updateFlag(this.props.id, true)
//                 })
//                 .catch(res => message.error('Could not add Credit Card'))
//         } else {
//             this.updateFlag(this.props.id, true)
//             this.setState({ visible: false })
//         }
//     }

//     updateFlag = (flag, value) => {
//         CloudFlyerAPI.user_account
//             .setConfirmedFlags({ [`confirmed_${flag}`]: value })
//             .then(() => this.props.refresh_profile(true))
//     }

//     handleConfirm = () => {
//         const { period, hasCard } = this.state
//         const role = this.props.user.role.title
//         if (role === 'Owner') {
//             if (hasCard) {
//                 this.confirm()
//             } else {
//                 this.setState({ addCardVisible: true, confirmed: true })
//             }
//         }
//     }

//     handleCancel = () => {
//         const { history } = this.props
//         this.setState({ visible: false })
//     }

//     componentDidMount() {
//         CloudFlyerAPI.billing.fetchPaymentProfiles().then(({ data }) => {
//             const hasCard = data['billing_payment_profiles'].length !== 0
//             this.setState({ hasCard })
//         })
//     }

//     render() {
//         const { user, quota, header } = this.props
//         const { confirmed, visible, cc, addCardVisible } = this.state
//         const role = user.role.title

//         return (
//             <Modal
//                 className="xchange-confirm-modal"
//                 visible={visible}
//                 width={700}
//                 onCancel={this.handleCancel}
//                 footer={
//                     addCardVisible && (
//                         <div className="footer-msg">
//                             <p>
//                                 Once you add your card, it will be charged the
//                                 agreed upon amount and will be saved.
//                             </p>
//                             <p>
//                                 You will always receive a confirmation email
//                                 following any transaction.
//                             </p>
//                             <p className="secure-form-txt">
//                                 <img
//                                     alt="secure lock icon"
//                                     src={SecureLockIcon}
//                                 />
//                                 &nbsp; Secure Form
//                             </p>
//                         </div>
//                     )
//                 }>
//                 <div>
//                     <h1>{header}</h1>
//                     <div>
//                         <p>
//                             Your account will be charged $0.15 per GB for cloud
//                             to cloud transfers.
//                         </p>
//                         <p>
//                             Please contact us if you would like to purchase a
//                             bulk license.
//                         </p>
//                     </div>
//                     <div className="confirm-container">
//                         <Button
//                             disabled={!confirmed || addCardVisible}
//                             size="large"
//                             type="primary"
//                             onClick={this.handleConfirm}>
//                             Confirm Transfer Charges
//                         </Button>
//                     </div>
//                     {addCardVisible && (
//                         <div>
//                             <Divider />
//                             <AddCardForm
//                                 loading={false}
//                                 on_save={this.confirm}
//                                 on_cancel={() => console.log('canceling ..')}
//                                 name={cc.name}
//                                 number={cc.number}
//                                 expiry={cc.expiry}
//                                 cvc={cc.cvc}
//                                 focused={cc.focused}
//                                 callback={this.ccCallback}
//                                 on_focus={this.handleCCFocus}
//                                 on_change={this.handleCCChange}
//                                 valid={cc.valid}
//                                 cardPosition="none"
//                             />
//                         </div>
//                     )}
//                 </div>
//             </Modal>
//         )
//     }
// }

export default withRouter(
    connect(
        state => {
            return {
                user: ((state || {}).auth || {}).user,
                bucket: ((state || {}).cloudFilesSystem || {}).bucket,
                current_path: ((state || {}).cloudFilesSystem || {})
                    .current_path,
                clouds: ((state || {}).cloudAccounts || []).items || [],
            }
        },
        dispatch =>
            bindActionCreators(
                {
                    refresh_rm,
                    fetchBucketContent,
                    selectBucket,
                    fetchCloudAccounts,
                    cloud_selection_changed,
                    clear_migration,
                    refresh_profile,
                    play_file,
                    dispatch,
                },
                dispatch
            )
    )(Xchange)
)


